import React from 'react';
import { Tooltip } from 'antd';
import styled from 'styled-components';

import { ABIcon } from '@/common/Icons/ABIcon';
import { AdaptiveIcon } from '@/common/Icons/AdaptiveIcon';
import { ADAPTIVE, RUNNING, STARTED } from '@/constants';
import { getColorByStatus } from '@/features/experiment/calendar/utils';

import './CalendarPageV2.css';

import { CalendarPageV2 } from './calendar-page-v2.1';

// Constants moved to @/features/experiment/calendar/constants

export function renderDayCell(dayRenderInfo) {
  const date = dayRenderInfo.date;
  const [currentDate, currentMonth] = [date.getDate(), date.getUTCMonth()];

  const today = new Date();
  const dayOfMonth = today.getUTCMonth();
  const day = today.getDate();

  return (
    <Day $primary={currentMonth === dayOfMonth && day === currentDate}>
      {currentDate}
    </Day>
  );
}

export function renderEventContent(eventInfo) {
  const runningStates = [STARTED, RUNNING];
  const { title } = eventInfo.event;
  const { type, status } = eventInfo.event.extendedProps;

  return (
    <Tooltip title={title} placement="topLeft">
      <EventWrapper>
        <IconWrapper>
          {type === ADAPTIVE ? (
            <AdaptiveIcon
              fillColour="#FFF"
              iconColor="rgb(139, 116, 255)"
              size="24"
              borderRadius="8"
              boxShadow="0px 4px 9px 0px #161A1D0D"
            />
          ) : (
            <ABIcon
              size="24"
              fillColor="#FFFFFF"
              borderRadius="8"
              boxShadow="0px 4px 9px 0px #161A1D0D"
              currentColor="#005339"
            />
          )}
        </IconWrapper>
        <TextWrapper>
          <Title>{title}</Title>
          <Status status={status}>
            {runningStates.includes(status) ? RUNNING : status}
          </Status>
        </TextWrapper>
      </EventWrapper>
    </Tooltip>
  );
}

export const Container = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  gap: 8px;
`;

export const Header = styled.div`
  height: 48px;
  padding-left: 16px;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 16px;
`;

const Title = styled.span`
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const EventWrapper = styled.div`
  display: flex;
  gap: 4px;
  padding-left: 4px;
  align-items: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const IconWrapper = styled.div`
  margin-top: 2px;
  box-shadow: 0px 4px 9px 0px #161a1d0d;
`;

const TextWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
interface StatusProps {
  status: string;
}

const Status = styled.span<StatusProps>`
  color: ${(props) => getColorByStatus(props.status)};
  font-size: 10px;
  margin-left: 4px;
`;

interface DayProps {
  $primary: boolean;
}

const Day = styled.div<DayProps>`
  width: 32px;
  height: 32px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  padding: 8px;
  border-radius: 100%;
  background: ${(props) => (props.$primary ? '#00B14F' : '')};
  color: ${(props) => (props.$primary ? '#FFFFFF' : '#000000')};
`;

export default CalendarPageV2;
